import { isStringAllLettersOrEmpty } from 'common/helpers';
import { removeAnyLeadingNonNumbers } from 'features/call/call-base/helpers';
import { ANONYMOUS } from 'features/voice-meeting/constants';

export const normalizeHearingInfoCallerNumber = (phoneNumber = '') => {
  let callerNumber = removeAnyLeadingNonNumbers(phoneNumber);

  if (isStringAllLettersOrEmpty(callerNumber)) {
    callerNumber = ANONYMOUS;
  }

  return callerNumber;
};
